import {gsap} from "../LibrariesImport";
export default class Banner {

	static init() {

		this.banner = document.querySelector(".banner");
		if( !this.banner ){
			return;
		}

		let btnScrolling = this.banner.querySelector('.banner-scrolling-indication');
		if( btnScrolling ) {
			btnScrolling.addEventListener('click', () => {
				gsap.to(window, {
					duration: 0.5,
					scrollTo: this.banner.offsetHeight
				});
			});
		}

	}

}
